//--------------------------------------------------------------------//
//******************** EmailSettingsService *****************************//
//--------------------------------------------------------------------//
// API communication layer for the Email feature - workspace-wide provider
// CRUD and per-user account CRUD (incl. signature), backed by
// conversation-nodejs's /email/* REST API (see conversation-nodejs's
// server/conversations/email/routes.js).
import { request } from './emailSettings.request.js';
import { GUDHUB_SETTINGS } from '../../config.js';
require('../../core/localizationService/localizationService.js');

angular.module('emailSettingsModule', ['localizationModule'])

    .service('EmailSettingsService', [function () {
        // Providers (workspace-wide, admin-managed).
        this.getProviders = function () {
            return request('/email/providers');
        };

        this.createProvider = function (providerData) {
            return request('/email/providers', {
                method: 'POST',
                body: JSON.stringify(providerData)
            });
        };

        this.updateProvider = function (providerId, providerData) {
            return request(`/email/providers/${encodeURIComponent(providerId)}`, {
                method: 'PUT',
                body: JSON.stringify(providerData)
            });
        };

        this.deleteProvider = function (providerId) {
            return request(`/email/providers/${encodeURIComponent(providerId)}`, {
                method: 'DELETE'
            });
        };

        // Accounts (per-user mailbox + signature). Secrets (imap/smtp
        // passwords) are never returned by the server.
        this.getAccounts = function (userId) {
            return request(`/email/accounts?user_id=${encodeURIComponent(userId)}`);
        };

        // Every account linked under one provider, across ALL users - backs
        // the provider detail popup's "Accounts" tab (mirrors the SIP
        // trunk's Numbers tab, also not scoped to the viewer).
        this.getAccountsByProvider = function (providerId) {
            return request(`/email/accounts?provider_id=${encodeURIComponent(providerId)}`);
        };

        this.createAccount = function (accountData) {
            return request('/email/accounts', {
                method: 'POST',
                body: JSON.stringify(accountData)
            });
        };

        this.updateAccount = function (accountId, accountData) {
            return request(`/email/accounts/${encodeURIComponent(accountId)}`, {
                method: 'PUT',
                body: JSON.stringify(accountData)
            });
        };

        this.deleteAccount = function (accountId) {
            return request(`/email/accounts/${encodeURIComponent(accountId)}`, {
                method: 'DELETE'
            });
        };

        // Attempts an IMAP connect+logout - for the "Test Connection" button.
        this.testConnection = function (accountId) {
            return request(`/email/accounts/${encodeURIComponent(accountId)}/test-connection`, {
                method: 'POST'
            });
        };

        // Not a fetch() call - navigates the popup window straight to Google's
        // consent screen (redirect chain lives entirely server-side).
        this.googleOAuthStartUrl = function (userId, providerId) {
            return `${GUDHUB_SETTINGS.conversation_server_url}/email/oauth/google/start?user_id=${encodeURIComponent(userId)}&provider_id=${encodeURIComponent(providerId)}`;
        };
    }]);
